import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hasErrorIndicator: {
		id: 'accessible-workflow-diagram.common.validation-indicator.has-error-indicator',
		defaultMessage: 'Has error.',
		description: 'Indicates that a status or transition has an error',
	},
	hasWarningIndicator: {
		id: 'accessible-workflow-diagram.common.validation-indicator.has-warning-indicator',
		defaultMessage: 'Has warning.',
		description: 'Indicates that a status or transition has a warning',
	},
});
